module.exports = __webpack_public_path__ + "img/mlk.95a3d95f.svg";